import React, { useEffect, useState, useRef, useContext } from "react";
//import { PlayerContext } from './PlayerProvider';
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { DOMURL, HLSJSVERSION } from '../../url';
import IconButton from "@material-ui/core/IconButton";
import VolumeUp from "@material-ui/icons/VolumeUp";
import VolumeDown from "@material-ui/icons/VolumeDown";
import VolumeMute from "@material-ui/icons/VolumeOff";
import Slider from "@material-ui/core/Slider";

function Player({ videoUrl, downloadUrlcookie, cookie, playing, playerref, volume, parent_entryid, isMuted, pageLink }) {
  // alert(playing)
  const [state, setState] = useState({
    playing: playing,
    controls: false,
    light: false,
    muted: false,
    volume: volume ? volume : 1,
    pageUrl: pageLink
  });

  useEffect(() => {
    // alert('isMuted'+isMuted)
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      // alert('reload')
      setState({
        ...state,
        muted: true,
        playing: playing !== undefined && playing !== null && playing !== "" ? playing : true,
        volume: volume ? volume : 1
      });
    } else {
      setState({
        ...state,
        muted: isMuted,
        playing: playing,
        volume: volume ? volume : 1
      });
    }
  }, [playing, volume]);



  //this is for zoom thumbnail on hover
  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem('isVideoThumbonHover') === 'true') {
        if (localStorage.getItem('isMutedThumbnailVideo') === 'true') {
          setState({ ...state, muted: true });
        } else {
          setState({ ...state, muted: false });
        }
      }

      console.log('isMutedThumbnailVideo' + localStorage.getItem('isMutedThumbnailVideo'))
    }, 50)
  }, [state.muted]);


  const hanldeMute = () => {
    setState({ ...state, muted: !state.muted });
    localStorage.setItem('isMutedThumbnailVideo', !state.muted)
  };
  const handleVolumeSeekDown = (e, newValue) => {
    setState({ ...state, seeking: false, volume: parseFloat(newValue / 100) });
    localStorage.setItem("reactplayer.volume", state.volume)
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
    localStorage.setItem("reactplayer.volume", state.volume)
  };

  const setCookie = (name, value, days) => {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name +
      "=" +
      (value || "") +
      expires +
      "; domain=.amritatvonline.com; path=/";
  }

  setCookie("CloudFront-Policy", cookie["CloudFront-Policy"], 1);
  setCookie("CloudFront-Signature", cookie["CloudFront-Signature"], 1);
  setCookie(
    "CloudFront-Key-Pair-Id",
    cookie["CloudFront-Key-Pair-Id"],
    1
  );

  //alert(downloadUrlcookie)
  return (<>
    {
      parent_entryid !== '' && parent_entryid !== null && parent_entryid !== undefined ?
        <Link to={parent_entryid !== "" ? `/video/cat/slider/${parent_entryid}` : ""}>
          <ReactPlayer
            id={`playerid`}
            ref={playerref}
            className="videoplayerwrapper"
            url={videoUrl}
            //url={'https://bitmovin-a.akamaihd.net/content/sintel/hls/playlist.m3u8'}
            //light={data.imgurl}

            onReady={(e) => {

            }
            }

            onStart={(e) => {

            }
            }

            onPlay={(e) => {

            }}

            onPause={(e) => {

            }
            }

            volume={state.volume}
            muted={state.muted}
            pip={true}
            loop={true}
            playing={state.playing}
            controls={false}

            config={{
              file: {
                forceHLS: true,
                forceVideo: true,
                attributes: {
                  crossOrigin: "use-credentials",
                },

                hlsOptions: {
                  forceHLS: true,
                  debug: true,
                  xhrSetup: function (xhr, url) {
                    // // //  
                    xhr.withCredentials = true; //send cookies
                    xhr.credentials = "include";
                    xhr.open("GET", url + downloadUrlcookie);
                    xhr.setRequestHeader(
                      "Access-Control-Allow-Headers",
                      "Accept,Origin,Content-Type,X-LS-CORS-Template,X-LS-Auth-Token,X-LS-Auth-User-Token,Content-Type,X-LS-Sync-Result,X-LS-Sequence,token"
                    );
                    xhr.setRequestHeader(
                      "Access-Control-Allow-Methods",
                      "POST, GET, OPTIONS, DELETE"
                    );
                    xhr.setRequestHeader("Access-Control-Allow-Origin", DOMURL);
                    xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");

                  },
                },
                hlsVersion: HLSJSVERSION,
              },
            }}
          />
        </Link> :
        <Link to={state.pageUrl}>
          <ReactPlayer
            id={`playerid`}
            ref={playerref}
            className="videoplayerwrapper"
            url={videoUrl}
            //url={'https://bitmovin-a.akamaihd.net/content/sintel/hls/playlist.m3u8'}
            //light={data.imgurl}

            onReady={(e) => {

            }
            }

            onStart={(e) => {

            }
            }

            onPlay={(e) => {

            }}

            onPause={(e) => {

            }
            }

            volume={state.volume}
            muted={state.muted}
            pip={true}
            loop={true}
            playing={state.playing}
            controls={false}

            config={{
              file: {
                forceHLS: true,
                forceVideo: true,
                attributes: {
                  crossOrigin: "use-credentials",
                },

                hlsOptions: {
                  forceHLS: true,
                  debug: true,
                  xhrSetup: function (xhr, url) {
                    // // //  
                    xhr.withCredentials = true; //send cookies
                    xhr.credentials = "include";
                    xhr.open("GET", url + downloadUrlcookie);
                    xhr.setRequestHeader(
                      "Access-Control-Allow-Headers",
                      "Accept,Origin,Content-Type,X-LS-CORS-Template,X-LS-Auth-Token,X-LS-Auth-User-Token,Content-Type,X-LS-Sync-Result,X-LS-Sequence,token"
                    );
                    xhr.setRequestHeader(
                      "Access-Control-Allow-Methods",
                      "POST, GET, OPTIONS, DELETE"
                    );
                    xhr.setRequestHeader("Access-Control-Allow-Origin", DOMURL);
                    xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");

                  },
                },
                hlsVersion: HLSJSVERSION,
              },
            }}
          />
        </Link>
    }

    {
      <div className="d-flex align-items-center vlm-icn">
        <IconButton
          onClick={hanldeMute}
          className={`bottomIcons volumeButton`}
        >
          {state.muted ? (
            <VolumeMute fontSize="small" />
          ) : state.volume > 0.5 ? (
            <VolumeUp fontSize="small" />
          ) : (
            <VolumeDown fontSize="small" />
          )}
        </IconButton>
        <Slider
          min={0}
          max={100}
          value={state.muted ? 0 : state.volume * 100}
          onChange={handleVolumeChange}
          aria-labelledby="input-slider"
          className={`range_vol volumeSlider`}
          onMouseDown={handleVolumeSeekDown}
          onChangeCommitted={handleVolumeSeekDown}
        />

      </div>
    }
  </>
  );
}
export default Player;